// @flow
import React from 'react';
import classnames from 'classnames';

import { Hero } from 'Components/widgets/hero/Hero.jsx';

type Props = {
  className?: string,
  hasInsetBorder?: boolean,
  insetBorderOffset?: number,
  immersiveSize?: ImmersiveSizeProps,
  src: string,
};

export function ImmersiveSlideShowItem(props: Props) {
  const { className, hasInsetBorder, immersiveSize = 'large', insetBorderOffset = 0, src } = props;

  return (
    <div className={classnames(className, 'relative')} key={src}>
      <Hero size={immersiveSize} url={src} />
      {hasInsetBorder && (
        <div
          className="absolute fadeIn inset-border h-full bottom-0 inset-x-0 pointer-events-none"
          style={{ height: `calc(100% - ${insetBorderOffset}px)` }}
        />
      )}
    </div>
  );
}
